import type { BrokerSusepScreening } from '@/shared/api/resources';

/**
 * A triagem impede o cadastro de forma definitiva para este CNPJ: o botao fica
 * bloqueado ate o CNPJ mudar. A SUSEP fora do ar tambem impede, mas a pessoa pode
 * tentar de novo.
 */
export function susepRecusouEsteCnpj(triagem: BrokerSusepScreening | null | undefined) {
  return Boolean(triagem && !triagem.proceed && triagem.status !== 'indisponivel');
}
